import React, { useEffect, useRef, useState } from "react";
/* {all css comes in channelRequest.css */

import axios from "../../../../../axios";
import moment from "moment";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IP } from "../../../../../internalServer";
import { Popup } from "semantic-ui-react";
import LikePopUp from "./popUpScreen";
import ThreeDot_Post_Popup from "./ThreeDot_Post_Popup";
import CreatePostFirst from "../../Create_Post_screen/CreatePostFirst";
import assets from "../../../../../assets/assets";
import LikePopupUI from "./LikePopupUI";

const PostImagePopup = ({
  setOpenPopup,
  post,
  commentLength,
  TotalCommuPost,
  refetch,
  setIsPostCreated1,
  community,
  members,
  setIsEdited,
}) => {
  const popupRef = useRef(null);
  const [replycpy, setreplyCnt] = useState(post);
  const [postThreedot, setPostThreedot] = useState(false);
  const [postLikeClick, setPostLikeClick] = useState(false);
  const [postLlikeCount, setPostLlikeCount] = useState(post?.like_count);
  const teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [isOpen, setIsOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(1);
  const [postEdit, setPostEdit] = useState(false);
  const [clickList, setClickList] = useState(false);

  // const [members, setMembers] = useState([]);
  const handleSlideChange = (current) => {
    setCurrentSlide(current + 1);
  };

  const [likedRes, setLikedRes] = useState(null);
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    afterChange: handleSlideChange,
    arrows: true,
  };
  useEffect(() => {
    if (post) {
      let isLiked = post?.likes?.some((like) => like.userId === teacher_id);
      setPostLikeClick(isLiked);
    }
  }, [post, teacher_id]);

  console.log(post, "post in popup");

  const handelPostLike = async (e) => {
    e.stopPropagation();
    try {
      let res = await axios.put(`/api/v1/community/post/like/${post.id}`, {
        user_id: teacher_id,
      });
      setPostLlikeCount(
        postLikeClick ? postLlikeCount - 1 : postLlikeCount + 1,
      );
      setPostLikeClick(!postLikeClick);
      setLikedRes(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    // Adding 5 hours and 30 minutes to the date
    dateObj.setUTCHours(dateObj.getUTCHours() + 5);
    dateObj.setUTCMinutes(dateObj.getUTCMinutes() + 30);

    const day = dateObj.getUTCDate();
    const month = dateObj.getUTCMonth() + 1;
    const year = dateObj.getUTCFullYear();
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getUTCSeconds();

    const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return outputDateString;
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setPostThreedot(false);
    }
  };
  useEffect(() => {
    if (likedRes) {
      setreplyCnt((prevReply) => ({ ...prevReply, ...likedRes }));
    }
  }, [likedRes]);

  return post && post?.community_id ? (
    <>
      <div
        className="post_img_container w-100  rounded-4"
        style={{ backgroundColor: "white" }}
      >
        <div
          className=" w-100 d-flex gap-2 flex-row "
          style={{ padding: "5px 10px" }}
        >
          {/* full post */}
          <div className="p-2 rounded-3 w-100" style={{ overflow: "hidden" }}>
            <div className="w-100 d-flex flex-row ">
              {/* Image */}
              <div className="gap-2 mt-1 mb-3 d-flex ">
                {post?.user_id?.user_type === "Teacher" ? (
                  <img
                    src={
                      post?.user_id?.profile_picture
                        ? IP + post?.user_id?.profile_picture.replace(/^\./, "")
                        : post?.user_id?.gender === "M"
                          ? "/images/Teacher_Male.jpg"
                          : post?.user_id?.gender === "F"
                            ? "/images/Teacher_Female.png"
                            : "/images/default-profile.png"
                    }
                    alt="icon"
                    className="profilePicImg"
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "20%",
                    }}
                    onError={(e) => {
                      // This function will run if the image fails to load
                      if (post?.user_id?.gender === "M") {
                        e.target.src = "/images/Teacher_Male.jpg";
                      } else if (post?.user_id?.gender === "F") {
                        e.target.src = "/images/Teacher_Female.png";
                      } else {
                        e.target.src = "/images/default-profile.png";
                      }
                    }}
                  />
                ) : (
                  <img
                    src={
                      post?.user_id?.profile_picture
                        ? IP + post?.user_id?.profile_picture.replace(/^\./, "")
                        : post?.user_id?.gender === "M"
                          ? post?.user_id?.avatar_profile
                            ? "/images/Boys/" +
                              post?.user_id?.avatar_profile +
                              ".webp"
                            : "/images/Student_boy_pic.png"
                          : post?.user_id?.gender === "F"
                            ? post?.user_id?.avatar_profile
                              ? "/images/Girls/" +
                                post?.user_id?.avatar_profile +
                                ".webp"
                              : "/images/Student_girl_pic.png"
                            : "/images/default image.png"
                    }
                    alt="icon"
                    className="prifilePicImg"
                    key={post?.user_id?.avatar_profile}
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "20%",
                    }}
                    onError={(e) => {
                      if (post?.user_id?.gender === "M") {
                        // console.log("insie if")
                        e.target.src = post?.user_id?.avatar_profile
                          ? "/images/Boys/" +
                            post?.user_id?.avatar_profile +
                            ".webp"
                          : "/images/Student_boy_pic.png";
                      } else if (post?.user_id?.gender === "F") {
                        e.target.src = post?.user_id?.avatar_profile
                          ? "/images/Girls/" +
                            post?.user_id?.avatar_profile +
                            ".webp"
                          : "/images/Student_girl_pic.png";
                      } else {
                        e.target.src = "/images/default image.png";
                      }
                    }}
                  />
                )}
              </div>
              <div className=" d-flex justify-content-between align-items-center px-4 py-1 w-100">
                <div>
                  <div className="d-flex align-items-center">
                    {post?.user_id?.user_type === "Teacher" && (
                      <img
                        className="mr-2"
                        src="/images/teacher_icon.svg"
                        alt=""
                      />
                    )}
                    <span className="request_channel_name mr-2">
                      {post?.user_id?.name}
                    </span>
                    {post?.user_id?.user_type === "Student" && (
                      <span className="request_channel_name mr-2">
                        &nbsp;
                        {post?.user_id?.standard?.name} -
                        {post?.user_id?.section?.name}
                      </span>
                    )}
                    <div className="m-0 p-0 post_tags_list d-flex align-items-center">
                      {post?.tags.length > 0 &&
                        post?.tags.map((tag, index) => (
                          <span
                            key={index}
                            className="related_postName mx-1  px-2 py-1"
                          >
                            {tag}
                          </span>
                        ))}
                    </div>
                  </div>
                  <div className=" request_created_by">
                    {post?.community_id?.community_name}
                  </div>
                  <small className=" request_created_by">
                    {moment(timeHelper(post?.created_at)).calendar({
                      sameDay: "[Today] hh:mm a",
                      lastDay: "[Yesterday] hh:mm a",
                      lastWeek: "DD MMM YYYY hh:mm a",
                      sameElse: "DD MMM YYYY hh:mm a",
                    })}
                  </small>
                </div>
                {TotalCommuPost === "TotalCommuPost" ? null : (
                  <>
                    {!post?.isDeleted ? (
                      <img
                        className="Post_HR_threedot"
                        src="/images/three dot hr.svg"
                        alt=""
                        height={"20px"}
                        width={"20px"}
                        onClick={() => setPostThreedot(!postThreedot)}
                      />
                    ) : (
                      <div className="delte">*Deleted</div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="mb-2 px-4 py-3 w-full">
              <div>
                <span className="post_description poppins-semibold">
                  {post?.description}
                </span>
              </div>
            </div>
            {post?.post_image?.length > 0 && (
              <div className="col-12 mt-3 mb-4 p-0 request_post_image_box">
                {post?.post_image?.length > 0 && (
                  <div className="slider_container">
                    <Slider {...settings}>
                      {post?.post_image?.length > 0 &&
                        post?.post_image?.map((item, idx) => {
                          return (
                            <div>
                              <img
                                key={idx}
                                src={`${IP + item}`}
                                className="request_post_image"
                                alt="img"
                                onError={(e) => {
                                  e.target.src = "/images/no-image5.png";
                                }}
                              />
                            </div>
                          );
                        })}
                    </Slider>
                    {post?.post_image?.length > 1 && (
                      <span className="post_image_count d-flex align-items-center justify-content-center">
                        {currentSlide}/{post?.post_image?.length}
                      </span>
                    )}
                  </div>
                )}
              </div>
            )}

            <div className="d-flex justify-content-between align-items-center border-bottom border-4 pb-2">
              <div className="d-flex gap-2 align-items-center">
                {!postLikeClick ? (
                  <img
                    src={assets.LikeIcon}
                    className="like_shear_img"
                    height={20}
                    width={20}
                    onClick={post?.isDeleted ? () => {} : handelPostLike}
                    alt=""
                  />
                ) : (
                  <img
                    src={assets.BlueLikeIcon}
                    className="like_shear_img"
                    height={20}
                    width={20}
                    onClick={handelPostLike}
                    alt=""
                  />
                )}{" "}
                <div
                  className="poppins-semibold mt-1"
                  style={{ fontSize: "14px", cursor: "pointer" }}
                >
                  {postLlikeCount}
                  <span onClick={() => setClickList(!clickList)}> Likes</span>
                </div>
              </div>

              {/* <small
                onClick={() => {
                  setIsOpen(true);
                }}
                className="poppins-semibold ms-4"
              >

                <span className="ms-1 poppins-semibold">
                  {postLlikeCount}{" "}
                  <Popup
                    on="click"
                    open={isOpen}
                    onOpen={() => {
                      if (postLlikeCount > 0) setIsOpen(true);
                    }}
                    onClose={() => setIsOpen(false)}
                    trigger={
                      <span>{postLlikeCount === 0 ? "Like" : "Likes"}</span>
                    }
                    position="bottom right"
                    content={
                      <LikePopUp
                        post={replycpy}
                        likedRes={likedRes || {}}
                        setIsOpen={setIsOpen}
                        isOpen={isOpen}
                      />
                    }
                  />
                </span>
              </small> */}
              <div className="me-4">
                <img
                  src={assets.commentIcon}
                  className="like_shear_img mr-1"
                  height={20}
                  width={20}
                  alt=""
                />
                <small className="poppins-semibold ms-1">
                  {commentLength
                    ? post?.comment_count + commentLength
                    : post?.comment_count}
                </small>

                <small className="poppins-semibold "> Comments</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      {postEdit && (
        <CreatePostFirst
          editingMode={true}
          post={post}
          setClickPost={setPostEdit}
          clickPost={postEdit}
          refetch1={refetch}
          setIsPostCreated2={setIsPostCreated1}
          setIsEdited={setIsEdited}
        />
      )}

      {postThreedot && (
        <div ref={popupRef} className="Post_popupBox">
          <ThreeDot_Post_Popup
            setPostThreedot={setPostThreedot}
            setPostEdit={setPostEdit}
            post_id={post?.id}
            communityId={post?.community_id?.id}
            members={members}
            post={post}
            setOpenPopup={setOpenPopup}
          />
        </div>
      )}
      {clickList && (
        <div
          style={{
            position: "relative",
          }}
        >
          <LikePopupUI
            post={replycpy}
            likedRes={likedRes || {}}
            setIsOpen={setClickList}
          />
        </div>
      )}
    </>
  ) : (
    <>{/* <img className="Loader" src="/gif/Loader.gif" alt="" /> */}</>
  );
};

export default PostImagePopup;

//
